<script lang="ts" setup>
import { computed, ref, watchEffect } from 'vue'

const props = defineProps<{
  seconds: number
}>()

const emit = defineEmits<{
  (event: 'end'): void
}>()

const duration = ref(props.seconds)

watchEffect(() => {
  const intervalId = setInterval(() => {
    duration.value--
    if (duration.value <= 0) {
      clearInterval(intervalId)
      emit('end')
    }
  }, 1000)

  return () => clearInterval(intervalId)
})

const days = computed(() => {
  return Math.floor(duration.value / 86400)
})
const hours = computed(() => {
  return Math.floor((duration.value % 86400) / 3600)
})
const minutes = computed(() => {
  return Math.floor((duration.value % 3600) / 60)
})
const seconds = computed(() => {
  return duration.value % 60
})
</script>

<template>
  <div>
    <slot v-bind="{ days, hours, minutes, seconds }">
      <div class="flex text-white text-12px text-center leading-21px">
        <span class="text-24px font-bold">{{ days }}</span>天
        <span class="text-24px font-bold">{{ hours }}: {{ minutes }} : {{ seconds }}</span>
      </div>
    </slot>
  </div>
</template>
